<template>
    <main-header :links="links"></main-header>
    <div class="content">
        
        <section id="login">
            <h1>{{ $t('login') }}</h1>
            <span class="error" v-if="error">{{ $t('login-error') }}</span>
            <form @submit="login">
                <label for="username">{{ $t('username') }}</label>
                <input type="text" id="username" placeholder="Username" v-model="username" required>
                <label for="password">{{ $t('password') }}</label>
                <input type="password" id="password" placeholder="Password" v-model="password" required>
                <!--<button class="btn-large" v-on:click="login">{{ $t('login-action') }}</button>-->
                <input type="submit" :value="$t('login-action')" class="btn-large">
            </form>

            <p class="disclaimer">{{ $t('login-cookie-disclaimer') }}</p>
        </section>



    </div>
</template>
<script>
import MainHeader from '@/components/MainHeader.vue';
import superagent from 'superagent';
import constants from '@/Constants.js';


export default {
    components: {
        MainHeader
    },
    methods: {
        async login (e) {
            e.preventDefault();
            this.error = false;
            try {
                const res = await superagent.post(`${constants.openApiUrl}/login`)
                    .send({
                        username: this.username,
                        password: this.password
                    });

                console.log(res.body);

                if (res.body.success) {
                    localStorage.setItem('token', res.body.token);
                    this.$router.push({name: 'dashboard'});
                } else {
                    this.error = true;
                }
            } catch (e) {
                this.error = true;
                console.error(e);
            }
        }
    },
    data () {
        return {
            username: '',
            password: '',
            error: false,
            links: [
            ]
        }
    }
}

</script>
<style scoped>

    .disclaimer {
        font-size: 0.8em;
        color: #888;
        margin-top: 10px;
    }


</style>
